import React, { useState } from 'react';
import { Lightbulb, ChevronDown } from 'lucide-react';

const EXAMPLE_PROMPTS = [
  'soft bridal glam with nude glossy lips',
  'dramatic smokey eye for evening look',
  'natural everyday makeup with fresh glow',
  'bold red lips with winged liner',
  'sun-kissed beach makeup with coral tones',
  'editorial high-fashion makeup'
];

const PromptBox = ({ value, onChange, disabled }) => {
  const [showExamples, setShowExamples] = useState(false);
  
  const handleExampleClick = (example) => {
    onChange(example);
    setShowExamples(false);
  };
  
  return (
    <div className="space-y-2">
      {/* Text Area */}
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder="e.g., 'soft bridal glam with natural pink lips' or 'bold evening look with smokey eyes'"
        rows={4}
        className="w-full px-4 py-3 rounded-xl border border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100 placeholder-zinc-400 dark:placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-pink-500/50 disabled:opacity-50 disabled:cursor-not-allowed resize-none"
      />
      
      {/* Character count */}
      <div className="flex items-center justify-between text-xs text-zinc-500 dark:text-zinc-400">
        <span>{value.length} / 500 characters</span>
        
        {/* Examples toggle */}
        <button
          type="button"
          onClick={() => setShowExamples(!showExamples)}
          className="flex items-center gap-1 hover:text-pink-500 transition-colors"
        >
          <Lightbulb className="h-3 w-3" />
          <span>Examples</span>
          <ChevronDown className={`h-3 w-3 transition-transform ${showExamples ? 'rotate-180' : ''}`} />
        </button>
      </div>
      
      {/* Example prompts */}
      {showExamples && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 p-3 bg-zinc-50 dark:bg-zinc-800/50 rounded-xl">
          {EXAMPLE_PROMPTS.map((example, index) => (
            <button
              key={index}
              type="button"
              onClick={() => handleExampleClick(example)}
              disabled={disabled}
              className="text-left px-3 py-2 rounded-lg bg-white dark:bg-zinc-700 hover:bg-pink-50 dark:hover:bg-pink-900/20 border border-zinc-200 dark:border-zinc-600 text-xs text-zinc-700 dark:text-zinc-300 transition-colors disabled:opacity-50"
            >
              "{example}"
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PromptBox;

